<template>
  <div v-if="voicebot" class="voicebot__container">
    <h3>{{ $tr(`responses.voicebot.title`) }}</h3>

    <video-player
      v-if="voicebot.file"
      :key="voicebot.file.source"
      :src="voicebot.file.source"
      :custom-class="'voicebot__player'"
    ></video-player>

    <div class="voicebot-navigation-list-wrapper">
      <div class="voicebot-navigation-list">
        <div
          v-for="(question, index) in voicebot.questions"
          :key="index"
          class="question-navigation"
        >
          <div class="number">{{ index + 1 }}</div>
          <div class="descr">{{ question.body }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import VideoPlayer from '@/components/VideoPlayer';

  export default {
    name: 'ResponseVoicebotScene',

    components: {
      VideoPlayer
    },

    props: {
      voicebot: Object
    }
  };
</script>

<style lang="scss">
  @import '@/styles/variables.scss';

  .voicebot__container {
    margin-right: 20px;
  }

  .voicebot__player .vjs-menu-button {
    display: inline-block;
  }

  .voicebot__player .video-js .vjs-play-progress:before {
    display: none;
  }

  .voicebot__player .vjs_video_3-dimensions.vjs-fluid {
    padding-top: 40px !important;
  }

  .voicebot__player .video-player .video-js {
    position: relative;
    padding-top: 40px;
  }

  .voicebot__player .video-player .vjs-big-play-button {
    display: none;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background-color: $green;
    opacity: 0.7;
    width: 100px;
    height: 55px;
    border-radius: 0;
    transition: opacity 0.8s;
  }

  .voicebot__player .video-player .vjs-big-play-button:hover {
    opacity: 1;
  }

  .voicebot__player .video-player .vjs-big-play-button .vjs-icon-placeholder:before {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 60px;
  }

  .voicebot__player .video-player .vjs-control-bar {
    display: block;
    opacity: 1 !important;
    background-color: #fff;
    height: 40px;
    border-left: 1px solid #dedede;
    border-bottom: 1px solid #dedede;
    border-right: 1px solid #dedede;
  }

  .voicebot__player .video-player .vjs-control-bar .vjs-play-control {
    width: 40px;
    height: 40px;
    border-right: 1px solid #dedede;
  }

  .voicebot__player .video-player .vjs-control-bar .vjs-play-control span {
    position: absolute;
    left: 35%;
    top: 25%;
    transform: translate(-50%, -50%);
  }

  .voicebot__player .vjs-icon-play:before,
  .video-js .vjs-big-play-button .vjs-icon-placeholder:before,
  .video-js .vjs-play-control .vjs-icon-placeholder:before {
    width: 0;
    height: 0;
    border-top: 10px solid transparent;
    border-left: 15px solid $green;
    border-bottom: 10px solid transparent;
    content: ' ';
  }

  .voicebot__player .vjs-icon-replay:before,
  .video-js .vjs-play-control.vjs-ended .vjs-icon-placeholder:before {
    width: 0;
    height: 0;
    border-top: 10px solid transparent;
    border-left: 15px solid $green;
    border-bottom: 10px solid transparent;
    content: ' ';
  }

  .voicebot__player .vjs-icon-pause:before,
  .video-js .vjs-play-control.vjs-playing .vjs-icon-placeholder:before {
    border: none;
    margin-left: -5px;
    width: 20px;
    height: 20px;
    background: url(/static/images/elements/pause-button.png) no-repeat center;
    content: ' ';
  }

  .voicebot__player .vjs-icon-fullscreen-enter:before,
  .video-js .vjs-fullscreen-control .vjs-icon-placeholder:before {
    display: none;
    border: none;
    margin-top: 10px;
    width: 20px;
    height: 20px;
    background: url(/static/images/elements/arrows-expand.png) no-repeat center;
    content: '';
  }

  .voicebot__player .vjs-icon-fullscreen-exit:before,
  .video-js.vjs-fullscreen .vjs-fullscreen-control .vjs-icon-placeholder:before {
    border: none;
    margin-top: 10px;
    width: 20px;
    height: 20px;
    background: url(/static/images/elements/exit-fullscreen.png) no-repeat center;
    content: ' ';
  }

  .voicebot__player .vjs-icon-volume-mute:before,
  .video-js .vjs-mute-control.vjs-vol-0 .vjs-icon-placeholder:before,
  .voicebot__player .vjs-icon-volume-low:before,
  .video-js .vjs-mute-control.vjs-vol-1 .vjs-icon-placeholder:before,
  .voicebot__player .vjs-icon-volume-mid:before,
  .video-js .vjs-mute-control.vjs-vol-2 .vjs-icon-placeholder:before,
  .voicebot__player .vjs-icon-volume-high:before,
  .video-js .vjs-mute-control .vjs-icon-placeholder:before {
    width: 20px;
    height: 20px;
    content: ' ';
    border: none;
  }

  .voicebot__player .vjs-icon-volume-mute:before,
  .video-js .vjs-mute-control.vjs-vol-0 .vjs-icon-placeholder:before {
    background: url(/static/images/elements/volume_mute.png) no-repeat center;
  }

  .voicebot__player .vjs-icon-volume-low:before,
  .video-js .vjs-mute-control.vjs-vol-1 .vjs-icon-placeholder:before {
    background: url(/static/images/elements/volume_low.png) no-repeat center;
  }

  .voicebot__player .vjs-icon-volume-mid:before,
  .video-js .vjs-mute-control.vjs-vol-2 .vjs-icon-placeholder:before {
    background: url(/static/images/elements/volume_mid.png) no-repeat center;
  }

  .voicebot__player .vjs-icon-volume-high:before,
  .video-js .vjs-mute-control .vjs-icon-placeholder:before {
    background: url(/static/images/elements/volume_high.png) no-repeat center;
  }

  .voicebot__player .video-js .vjs-fullscreen-control {
    display: none;
    position: absolute;
    right: -10px;
  }

  .voicebot__player .video-js .vjs-progress-control .vjs-progress-holder {
    margin: 0;
  }

  .voicebot__player .video-js .vjs-progress-control {
    width: 100%;
    position: absolute;
    top: -5px;
    height: 10px;
  }

  .voicebot__player .video-js .vjs-slider {
    background-color: #dedede;
  }

  .voicebot__player .video-js .vjs-progress-holder .vjs-play-progress {
    background-color: $green;
  }

  .voicebot__player .video-js .vjs-volume-panel {
    right: 30px;
    position: absolute;
    top: 9px;
  }

  .voicebot__player .video-js .vjs-volume-bar {
    position: absolute;
    top: -4px;
    right: 5px;
  }

  .voicebot__player .video-js .vjs-volume-level {
    background-color: #aaa;
  }

  .voicebot__player .vjs-slider-horizontal .vjs-volume-level:before {
    color: #666;
  }

  .voicebot__player .vjs-time-divider {
    display: inline-block;
    top: 0;
    left: 90px;
    position: absolute;
  }

  .voicebot__player .video-js .vjs-duration,
  .vjs-no-flex .vjs-duration {
    display: inline-block;
    top: 0;
    left: 100px;
    position: absolute;
  }

  .voicebot__player .video-js .vjs-time-control {
    min-width: 0;
    padding-left: 0.3rem;
    padding-right: 0;
    font-size: 14px;
    text-align: center;
    height: 30px;
  }

  .voicebot__player .video-js .vjs-current-time,
  .vjs-no-flex .vjs-current-time,
  .voicebot__player .video-js .vjs-duration,
  .vjs-no-flex .vjs-duration {
    display: inline-block;
  }

  .voicebot__player .vjs-current-time-display {
    margin-left: 15px;
    top: -10px;
    position: absolute;
  }

  .voicebot__player .vjs-playback-rate > .vjs-menu-button,
  .vjs-playback-rate {
    display: none;
  }

  .voicebot__player .video-js .vjs-big-play-button:after {
    width: 0;
    height: 0;
    border-top: 15px solid transparent;
    border-left: 25px solid #fff;
    border-bottom: 15px solid transparent;
    content: ' ';
    display: block;
    position: absolute;
    left: 38px;
    top: 11px;
  }

  .voicebot__player .video-js .vjs-volume-panel.vjs-volume-panel-horizontal {
    width: 9em;
    transition: width 0.1s;
  }

  .voicebot__player .video-js .vjs-volume-panel .vjs-volume-control.vjs-volume-horizontal {
    width: 50px;
    opacity: 1;
  }

  .voicebot-navigation-list-wrapper {
    border-top: 1px solid #d9d9da;
    overflow: hidden;
    position: relative;
  }

  .voicebot-navigation-list .question-navigation {
    display: flex;
    padding: 23px 60px 30px 6px;
    border-bottom: 1px solid #d9d9da;
  }

  .voicebot-navigation-list .question-navigation .number {
    flex: none;
    width: 28px;
    height: 28px;
    line-height: 26px;
    text-align: center;
    color: $green;
    font-weight: bold;
    border: 2px solid $green;
    border-radius: 50%;
  }

  .voicebot-navigation-list .question-navigation .descr {
    margin-left: 12px;
    line-height: 20px;
    font-weight: 500;
    padding-top: 4px;
  }
</style>
